import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateRatesPerSupplier = (frameworkAgreementId, lotId, values) => {
  return axios.put(
    `/api/framework_agreements/${frameworkAgreementId}/setup/lots/${lotId}/rates_per_supplier`,
    values
  );
};

export const useUpdateRatesPerSupplier = (frameworkAgreementId, lotId) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => updateRatesPerSupplier(frameworkAgreementId, lotId, values),
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
